// ── Shared utilities (used by cart-drawer) ────────────────────────────────────
window.BlocUtils = {
  fmt: function (cents, currency) {
    return (cents / 100).toLocaleString('de-CH', { style: 'currency', currency: currency });
  },
};
